import { Component, OnInit, Input } from '@angular/core';
import { Acuerdo } from '../acuerdo.model';
import { User } from '../../security/user/user.model';
import { BackendService } from '../../core/backend.service';
import { ApiService } from '../../core/api.service';
import { SnackService } from '../../shared-services/snack.service';
import { FormControl } from '@angular/forms';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { MatAutocompleteSelectedEvent } from '@angular/material';
declare function escape(s: string): string;

@Component({
  selector: 'app-change-ejecutivo-cuenta',
  templateUrl: './change-ejecutivo-cuenta.component.html',
  styleUrls: ['./change-ejecutivo-cuenta.component.scss']
})
export class ChangeEjecutivoCuentaComponent implements OnInit {

  @Input() acuerdo: Acuerdo;
  @Input() cambioEjecutivo: User;
  myControl2 = new FormControl();
  filteredOptionsUsuario: Observable<string[]>;
  private staticCambioEjecutivo: User;
  private staticAcuerdo = { acuerdo: '' };
  validDates = [];
  usuarios: User[];
  loadingUsuarios = false;


  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  constructor(
    private backendService: BackendService,
    private apiService: ApiService,
    private snackService: SnackService
  ) { }

  ngOnInit() {
    this.staticCambioEjecutivo = this.cambioEjecutivo;
    this.getUsuarios();

    this.filteredOptionsUsuario = this.myControl2.valueChanges.pipe(
      startWith(null),
      map((opt: string | null) => opt ? this._filter(opt, this.usuarios) : this.usuarios));

    this.myControl2.setValue(this.acuerdo.ejecutivoCuenta);

  }

  usuarioSelected(event: MatAutocompleteSelectedEvent): void {
    this.acuerdo.ejecutivoCuenta = event.option.value;
  }

  onBlurUsuario(): void {
    if (this.acuerdo.ejecutivoCuenta !== this.myControl2.value) {
      this.myControl2.setErrors({'required' : true});
      this.myControl2.setValue('');
      this.acuerdo.ejecutivoCuenta = this.backendService.new(User);
    }
  }

  displayFnUsuario(usuario?: User): string | undefined {
    return usuario ? (usuario.name + ' ' + usuario.lastname) : undefined;
  }

  private _filter(value: any, options: any[]): any[] {
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase();
    return options.filter(opt => opt.name.toLowerCase().indexOf(filterValue) === 0);
  }

  async getUsuarios() {
    this.loadingUsuarios = true;
    this.backendService
        .get(User, User.path + 'all', {}).toPromise()
        .then(opts => {
                this.loadingUsuarios = false;
                this.usuarios = Array.from(opts);
                this.filteredOptionsUsuario = this.myControl2.valueChanges
                .pipe(startWith(null),
                 map((opt: string | null) => opt ? this._filter(opt, this.usuarios) : this.usuarios));

    });
  }


  async save() {

    this.snackService.spinner(true);
    try {

      await this.backendService.update(Acuerdo.path + 'update-ejecutivo/' + this.acuerdo.id, this.acuerdo);
      this.snackService.success('Ejecutivo de cuenta actualizado');

      this.updateView();
      this.snackService.spinner(false);
    } catch (error) {
      this.snackService.spinner(false);
      this.snackService.error(error.message);
    }
  }

  updateView() {
    this.staticCambioEjecutivo.name = this.acuerdo.ejecutivoCuenta.name;
    this.staticCambioEjecutivo.lastname = this.acuerdo.ejecutivoCuenta.lastname;
  }

}



// WEBPACK FOOTER //
// ./src/app/acuerdo/change-ejecutivo-cuenta/change-ejecutivo-cuenta.component.ts